import React, { ReactElement, useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMutationGoogleLogin } from '@hooks/api/auth/useFetchGoogleLogin';
import { BasicResponseBinderGoogleAccessToken } from '@src/api';
import { GOOGLE_REDIRECT_URL } from '@src/constants/constant';
import { Logo } from '@components/layout';
import { useAtom } from 'jotai';
import { authAtom } from '@src/store/auth';

const { confirm } = Modal;

interface LoginFormProps {
  showLoading?: boolean;
  extra?: string | ReactElement;
  loading?: boolean;
  showMessage?: string;
  message?: string;
}

const GoogleLoginCallback = (props: LoginFormProps) => {
  const navigate = useNavigate();
  const [authInfo, setAuthInfo] = useAtom(authAtom);

  const [googleLoginCode, setGoogleLoginCode] = useState(() => {
    const params = new URL(window.location.href).searchParams;
    const code = params.get('code');
    return code;
  });

  const [isLoading, setLoading] = useState(false);

  const googleSignIn = useMutationGoogleLogin({
    options: {
      onSuccess: async (response: BasicResponseBinderGoogleAccessToken) => {
        setAuthInfo(response.data);
        navigate('/app/realtime', {
          state: { justLoggedIn: true },
        });
      },
      onError: (error: any) => {
        confirm({
          type: 'error',
          title: '오류',
          content: '로그인에 실패 했습니다. 다시 시도해 주세요.',
          okText: '확인',
          cancelText: '취소',
          onOk() {
            window.localStorage.removeItem('auth-info');
            navigate('/login');
          },
          onCancel() {
            window.localStorage.removeItem('auth-info');
            navigate('/login');
          },
        });
      },
      onSettled: () => {
        console.log('onSettled');
        setLoading(false);
      },
    },
  });

  useEffect(() => {
    if (!googleLoginCode) {
      confirm({
        title: '안내',
        content: '잘못된 접근 입니다.',
        okText: '확인',
        okCancel: false,
        onOk() {
          navigate('/login');
        },
      });

      return;
    }

    setLoading(true);
    googleSignIn.mutate({
      code: googleLoginCode,
      redirectUri: GOOGLE_REDIRECT_URL,
    });
  }, [googleLoginCode]);

  return (
    <div className={'login-container'}>
      <div className={'login-wrap'}>
        <Logo mobileLogo={false} />
        <div className={'text'}>로그인 중입니다...</div>
        <Spin></Spin>
      </div>
    </div>
  );
};

export default GoogleLoginCallback;
